if (typeof window.SectionFeaturesWithMarquee === 'undefined') {
  class SectionFeaturesWithMarquee {
    constructor(splideContainer) {
      this.splideContainer = splideContainer;
    this.splideList = this.splideContainer?.querySelector('.splide__list');
    this.breakpoint = window.matchMedia('(min-width: 1024px)');
    this.splideInstance = undefined;
    this.handleResize = this.checkBreakpoint.bind(this);
    this.init();
  }

  init() {
    if (!this.splideContainer || typeof window.Splide === 'undefined') return;
    this.checkBreakpoint();
    this.breakpoint.addEventListener('change', () => this.checkBreakpoint());
    window.addEventListener('resize', this.handleResize);
  }

  checkBreakpoint() {
    if (this.breakpoint.matches) {
      this.destroySplide();
    } else {
      this.enableSplide();
    }
  }

  enableSplide() {
    if (!this.splideInstance) {
      if (this.splideList) {
        this.splideList.style.gridTemplateColumns = '';
      }
      this.splideInstance = new window.Splide(this.splideContainer, {
        arrows: false,
        type: 'slide',
        autoWidth: true,
        gap: '2rem',
        pagination: true,
        duration: 1500,
        dragMinThreshold: 5,
        flickPower: 100,
        speed: 500,
        easing: 'cubic-bezier(0.455, 0.03, 0.515, 0.955)',
      }).mount();
    }
  }

  destroySplide() {
    if (this.splideInstance) {
      this.splideInstance.destroy();
      this.splideInstance = undefined;
    }
    if (this.splideList) {
      const count = this.splideList.querySelectorAll('.splide__slide').length;
      this.splideList.style.gridTemplateColumns = `repeat(${count}, 1fr)`;
    }
  }
}

  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.js-features-with-marquee-splide').forEach(function(splide) {
      new SectionFeaturesWithMarquee(splide);
    });
  });
}